import React from 'react'
import healthcare1 from '../images/ws1.png';
import healthcare2 from '../images/ws2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function OfficeManagementSoftware() {
  return (
    <>
      <section id="portfolio" className="container my-5">
        <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
          <div className="px-3 fw-bold responsive-heading">
            <span className="highlight-orange">Integrated Office Management System</span> – All Operations in One Smart Platform
          </div>
        </div>
      </section>

      <section className="container my-5">
        {/* Section 1: Project Overview */}
        <div className="row g-0 overflow-hidden shadow rounded">
          <div className="col-12 col-md-5">
            <img
              src={healthcare1}
              alt="Office Management System Overview"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">Integrated Office Management System</span> – Centralized Workplace Operations Platform
            </h1>

            <p className="mb-3 ps-1">
              The Integrated Office Management System is a unified digital platform designed to manage all office
              operations from a single dashboard — including employees, departments, attendance, assets, and
              internal workflows.
            </p>

            <p className="mb-3 ps-1">
              By eliminating multiple disconnected tools, the system brings HR, administration, task management,
              approvals, and reporting into one seamless ecosystem, enabling organizations to operate efficiently
              with complete transparency and control.
            </p>

            {/* ROI Highlight Section */}
            <p className="mb-3 ps-1 fw-bold">
              <span className="highlight-orange">Measurable Business Impact & ROI:</span>
            </p>

            <p className="mb-2 ps-3">
              <span className="highlight-orange fw-bold">35–45%</span> reduction in manual administrative workload through automation
              of attendance, approvals, and reporting processes.
            </p>

            <p className="mb-2 ps-3">
              <span className="highlight-orange fw-bold">25–30%</span> improvement in employee productivity by centralizing tasks,
              communication, and performance tracking.
            </p>

            <p className="mb-2 ps-3">
              <span className="highlight-orange fw-bold">40%</span> faster decision-making enabled by real-time dashboards,
              centralized data access, and automated insights.
            </p>

            <p className="mb-3 ps-3">
              <span className="highlight-orange fw-bold">60%</span> reduction in operational errors and data duplication by replacing
              spreadsheets and disconnected systems with a single source of truth.
            </p>

            <p className="mb-4 ps-1">
              The result is a highly scalable office management solution that delivers long-term cost savings,
              improved workforce efficiency, and a strong return on investment within the first few months
              of deployment.
            </p>

            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>

        </div>

        {/* Section 2: Summary & Team Info */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
              <span className="highlight-orange">Product:</span> Integrated Office Management System
            </h1>

            <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
            <p className="mb-3 ps-3">India</p>

            <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
            <p className="mb-3 ps-3">
              Office Automation Platform, HR & Admin Management, Attendance & Leave System,
              Task & Workflow Automation, React, Node.js, Firebase, REST APIs,
              Role-Based Access Control
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
            <p className="mb-3 ps-3">Enterprise Office & Business Management</p>

            <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
            <p className="mb-3 ps-3">
              UI/UX Designer, Frontend Engineers, Backend Developer,
              System Architect, QA Engineer
            </p>

            <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
            <p className="mb-4 ps-3">6 to 8 Months</p>

            <p className="mb-4 ps-3">
              The Integrated Office Management System centralizes all organizational operations into a
              single powerful platform. From employee onboarding and attendance tracking to task
              assignments, approval workflows, asset management, and internal communication —
              everything is managed in one place.
              <br /><br />
              The platform improves operational visibility, reduces manual paperwork, and enhances
              coordination between departments. With role-based dashboards, automated workflows,
              and real-time reporting, organizations gain complete control over daily operations while
              significantly improving productivity and accountability.
            </p>

            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Contact Us
            </a>
          </div>

          <div className="col-12 col-md-5">
            <img
              src={healthcare2}
              alt="Office Management Dashboard"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>
        </div>

        {/* Section 3: Process & Key Features */}
        <div className="row g-0 overflow-hidden shadow rounded my-5">
          <div className="col-12 col-md-5">
            <img
              src={healthcare3}
              alt="Office Automation Features"
              className="img-fluid w-100 h-100 object-fit-cover"
            />
          </div>

          <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
            <h1 className="fw-bold mb-3">
              <span className="highlight-orange">Process</span>
            </h1>

            <p className="mb-3 ps-1">
              We built the Integrated Office Management System using a scalable, modular architecture
              that adapts to the evolving needs of modern organizations. The system connects all
              departments through centralized data management, automated workflows, and secure
              access controls.
            </p>

            <p className="mb-3 ps-1">
              A clean and intuitive UI/UX ensures smooth adoption across teams. Employees, managers,
              and administrators can easily manage daily operations, approvals, attendance, and
              reporting without technical complexity — improving efficiency at every level.
            </p>

            <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
            <ul className="ps-3 mb-4">
              <li className="mb-1">Employee & department management</li>
              <li className="mb-1">Attendance, leave & shift tracking</li>
              <li className="mb-1">Task assignment & approval workflows</li>
              <li className="mb-1">Asset & resource management</li>
              <li className="mb-1">Role-based dashboards with real-time reports</li>
            </ul>

            <a
              href="/contact-us"
              className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
            >
              Get Started
            </a>
          </div>
        </div>



        <OurPartner />
      </section >

    </>
  )
}

export default OfficeManagementSoftware